var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotiIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "25px",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "43D4E262-777D-461E-9D83-C06FFCD94919") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.827451 0 0 0 0 0.368627 0 0 0 0 0.403922 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBule---Milestone-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "16.0_Campaign_15.9",
    transform: "translate(-338.000000, -308.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Noti",
    transform: "translate(328.000000, 303.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Text-Fill",
    transform: "translate(10.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Left",
    transform: "translate(0.000000, 5.500000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-3)",
    id: "megaphone-(3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3554688,7.38461538 L19.421875,7.38461538 C19.0659219,7.38461538 18.7773438,7.66014359 18.7773438,8 C18.7773438,8.33985641 19.0659219,8.61538462 19.421875,8.61538462 L21.3554688,8.61538462 C21.7114219,8.61538462 22,8.33985641 22,8 C22,7.66014359 21.7114219,7.38461538 21.3554688,7.38461538 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5221758,11.2571897 L19.2331133,10.0264205 C18.9814453,9.78613333 18.5733281,9.78613333 18.3216172,10.0264205 C18.0698633,10.2667077 18.0698633,10.6563692 18.3216172,10.8966974 L19.6106797,12.1274667 C19.8623477,12.3677949 20.2705078,12.3677949 20.5221758,12.1274667 C20.7738867,11.8871385 20.7738867,11.4975179 20.5221758,11.2571897 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5221328,3.87257436 C20.2704648,3.63228718 19.8623477,3.63228718 19.6106367,3.87257436 L18.3215742,5.10334359 C18.0698633,5.34367179 18.0698633,5.73329231 18.3215742,5.97362051 C18.5732852,6.21394872 18.9814023,6.21390769 19.2330703,5.97362051 L20.5221328,4.74285128 C20.7738438,4.50252308 20.7738438,4.11290256 20.5221328,3.87257436 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9101562,0 C13.9420273,0 13.1379102,0.682871795 12.9981758,1.57062564 L12.4102344,2.13197949 C11.3869336,3.10900513 9.87993359,3.69230769 8.37890625,3.69230769 L4.51171875,3.69230769 C3.67146484,3.69230769 2.95504687,4.20681026 2.68898437,4.92307692 L2.578125,4.92307692 C1.15654687,4.92307692 0,6.02732308 0,7.38461538 C0,8.74190769 1.15654688,9.84615385 2.578125,9.84615385 L2.68898437,9.84615385 C2.88350391,10.3698051 3.31873438,10.7853538 3.8671875,10.9710769 L3.8671875,14.1538462 C3.8671875,15.1718154 4.73464063,16 5.80082422,16 C6.86696484,16 7.734375,15.1718154 7.734375,14.1538462 L7.734375,11.0769231 L8.37890625,11.0769231 C9.87989063,11.0769231 11.3868906,11.6602256 12.4102344,12.6372513 L12.9981758,13.1986051 C13.1379102,14.0863179 13.9420703,14.7692308 14.9101992,14.7692308 C15.9763398,14.7692308 16.84375,13.9410462 16.84375,12.9230769 L16.84375,1.84615385 C16.84375,0.828184615 15.9763398,0 14.9101562,0 Z M2.578125,8.61538462 C1.86733594,8.61538462 1.2890625,8.06326154 1.2890625,7.38461538 C1.2890625,6.70596923 1.86733594,6.15384615 2.578125,6.15384615 L2.578125,8.61538462 Z M6.4453125,14.1538462 C6.4453125,14.4931692 6.15617578,14.7692308 5.80078125,14.7692308 C5.44538672,14.7692308 5.15625,14.4931692 5.15625,14.1538462 L5.15625,11.0769231 L6.4453125,11.0769231 L6.4453125,14.1538462 Z M7.734375,9.84615385 L4.51171875,9.84615385 C4.15632422,9.84615385 3.8671875,9.57009231 3.8671875,9.23076923 L3.8671875,5.53846154 C3.8671875,5.19913846 4.15632422,4.92307692 4.51171875,4.92307692 L7.734375,4.92307692 L7.734375,9.84615385 Z M12.9765625,11.4603487 C11.8876914,10.5605744 10.4877266,10.0015179 9.01914063,9.87405128 L9.01918359,4.89513846 C10.4877266,4.76771282 11.8876914,4.20865641 12.9765625,3.30884103 L12.9765625,11.4603487 Z M15.5546875,12.9230769 C15.5546875,13.2624 15.2655508,13.5384615 14.9101992,13.5384615 L14.9101562,13.5384615 C14.5547617,13.5384615 14.265625,13.2624 14.265625,12.9230769 L14.265625,1.84615385 C14.265625,1.50683077 14.5547617,1.23076923 14.9101992,1.23076923 C15.2655508,1.23076923 15.5546875,1.50683077 15.5546875,1.84615385 L15.5546875,12.9230769 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotiIcon);
export default __webpack_public_path__ + "static/media/NotiIcon.25b305546828529f26122aec7de8c334.svg";
export { ForwardRef as ReactComponent };